import React, { useState } from 'react';

import { determineAlignmentType } from '../utilities';

import { ReactComponent as LeftAlignmentButton } from 'assets/images/left-alignment-toggle-icon.svg';
import { ReactComponent as CenterAlignmentButton } from 'assets/images/center-alignment-toggle-icon.svg';
import { ReactComponent as RightAlignmentButton } from 'assets/images/right-alignment-toggle-icon.svg';

import './index.scss';

function AlignmentMenuItem(props) {

  const [values, setValues] = useState(props.values);

  const alignment = determineAlignmentType(values);

  function handleAlignLeftControlClick() {

    let value = {
      marginLeft: null,
      marginRight: 'auto'
    };

    setValues(value);
    props.onChange(value);

  }

  function handleAlignCenterControlClick() {

    let value = {
      marginLeft: 'auto',
      marginRight: 'auto'
    };

    setValues(value);
    props.onChange(value);

  }

  function handleAlignRightControlClick() {

    let value = {
      marginLeft: 'auto',
      marginRight: null
    };

    setValues(value);
    props.onChange(value);

  }

  function renderMain() {

    const leftAlignmentButtonAttributes = {
      className: 'align-control',
      onClick() {
        handleAlignLeftControlClick();
      }
    };

    const centerAlignmentButtonAttributes = {
      className: 'align-control',
      onClick() {
        handleAlignCenterControlClick();
      }
    };

    const rightAlignmentButtonAttributes = {
      className: 'align-control',
      onClick() {
        handleAlignRightControlClick();
      }
    };

    if (alignment === AlignmentMenuItem.types.LEFT) {
      leftAlignmentButtonAttributes.className += ' selected';
    }

    if (alignment === AlignmentMenuItem.types.CENTER) {
      centerAlignmentButtonAttributes.className += ' selected';
    }

    if (alignment === AlignmentMenuItem.types.RIGHT) {
      rightAlignmentButtonAttributes.className += ' selected';
    }

    return <div className="alignment-menu-item-main">

      <div className="alignment-menu-item-controls">
        <button {...leftAlignmentButtonAttributes}>
          <LeftAlignmentButton />
        </button>
        <button {...centerAlignmentButtonAttributes}>
          <CenterAlignmentButton />
        </button>
        <button {...rightAlignmentButtonAttributes}>
          <RightAlignmentButton />
        </button>
      </div>

    </div>;
  }

  return renderMain();
}

AlignmentMenuItem.types = {
  LEFT: 'LEFT',
  CENTER: 'CENTER',
  RIGHT: 'RIGHT'
};

export default AlignmentMenuItem;